import { Button, Grid, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { Fragment, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import payMent from "../../../../../assets/images/payBg.svg";

// Function to mask the merchantId
const maskMerchantId = (merchantId) => {
  if (merchantId.length <= 4) {
    return merchantId; // If the ID is too short to mask, return as is
  }
  const firstTwo = merchantId.slice(0, 2);
  const lastTwo = merchantId.slice(-2);
  const middleAsterisks = '*'.repeat(merchantId.length - 4);
  return `${firstTwo}${middleAsterisks}${lastTwo}`;
};

const PhonePayEnquiry = () => {
  const dispatch = useDispatch();
  const [merchantId, setMerchantId] = useState("");
  const [url, setUrl] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [data, setData] = useState(null);
  const outlet_id = localStorage.getItem("outlet_id");

  const getMerchantID = () => {
    axios
      .get(`/v1/transaction_provider/${outlet_id}`)
      .then((res) => {
        const providerData = res.data[0];
        setMerchantId(providerData.merchant_id);
        setUrl(providerData.url);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const phonePayEnquiry = () => {
    axios
      .get(`${url}/payment/status/${merchantId}/${transactionId}`)
      .then((res) => {
        console.log(res);
        dispatch(setSnackbar(true, "error", res.data.message));
        setData(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleClick = () => {
    if (transactionId.length > 0) {
      phonePayEnquiry();
    } else {
      dispatch(setSnackbar(true, "error", "Please enter the transaction id"));
    }
  };

  useEffect(() => {
    getMerchantID();
  }, []);

  console.log(data);

  return (
    <Fragment>
      <Helmet>
        <title>PhonePe Enquiry</title>
      </Helmet>
      <Typography variant="h6">Phone Pay Enquiry</Typography>
      <Typography sx={{ marginBlockStart: "20px" }} fontSize={16} fontWeight={600} color={"#A06EE1"}>Transaction Id</Typography>
      <Grid container columnSpacing={2} sx={{ marginBlockEnd: "30px" }}>
        <Grid item xs={12} sm={6} md={6}>
          <TextField
            size="small"
            placeholder="Transaction Id"
            fullWidth
            value={transactionId}
            onChange={(e) => setTransactionId(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <Button variant="outlined" onClick={handleClick}>
            Go
          </Button>
        </Grid>
      </Grid>
      <Grid
        sx={{
          backgroundImage: `url(${payMent})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          height: "280px",
          textAlign: "center",
          display: 'grid',
          alignItems: 'center',
          alignContent: 'space-evenly',
        }}
      >
        {!data || Object.keys(data).length === 0 ? (
          <Typography>No data here</Typography>
        ) : (
          <>
            <Typography><span style={{ fontWeight: "bold" }}>Transaction ID :</span> {data.transactionId}</Typography>
            <Typography><span style={{ fontWeight: "bold" }}>Merchant Order ID :</span> {data.merchantOrderId}</Typography>
            <Typography><span style={{ fontWeight: "bold" }}>Merchant ID :</span> {maskMerchantId(data.merchantId)}</Typography>
            <Typography><span style={{ fontWeight: "bold" }}>Amount :</span> {data.amount}</Typography>
            <Typography><span style={{ fontWeight: "bold" }}>Payment Status :</span> <span style={{ color: data.paymentState === 'CANCELLED' ? "red" : "green", fontWeight: "bold" }}>{data.paymentState}</span></Typography>
          </>
        )}
      </Grid>
    </Fragment>
  );
};

export default PhonePayEnquiry;
